import {
	getCampaignParamsFromRoute,
	hasCampaignInStorage,
	routeHasCampaignParams,
	setAdCampaignInStorage
} from '~/composables/adCampaign/utils';
import { toRaw } from 'vue';

export default defineNuxtRouteMiddleware(to => {
	if (import.meta.client && !hasCampaignInStorage()) {
		const hasCampaignParams = routeHasCampaignParams(to);

		if (hasCampaignParams) {
			const campaignParams = getCampaignParamsFromRoute(to);
			setAdCampaignInStorage(toRaw(campaignParams));
		}
	}
});
